import { makeStyles } from "@material-ui/core/styles";

const useStyle = makeStyles(( theme ) => ({
  
  threadContainer: {
    maxHeight: 400,
    overflowY: "auto"
  },
  editorContainer: {
    width: "100%",
    margin: 8,
    padding: 8,
    borderRadius: 5,
    backgroundColor: theme.props.backgroundLevel2,
  },
  moreIndicator: {
    color: theme.palette.primary.main,
    fontSize: 16,
    fontWeight: 600,
    padding: 8,
    margin: 8,
    borderRadius: 5,
    backgroundColor: theme.props.backgroundLevel2,
    width: "100%",
  }
}));

export default useStyle;